import type { PieceType, CertificationType, BlockCategory } from '../types/dossier-company.types';

/**
 * Sprint 5 v3 — Libellés UI des enums Prisma.
 */

export const PIECE_TYPE_LABELS: Record<PieceType, string> = {
  KBIS: 'K-bis',
  ATTESTATION_URSSAF: 'Attestation URSSAF',
  ATTESTATION_FISCALE: 'Attestation fiscale',
  ASSURANCE_RC_PRO: 'Assurance RC pro',
  ISO_9001: 'Certificat ISO 9001',
  ISO_14001: 'Certificat ISO 14001',
  ISO_27001: 'Certificat ISO 27001',
  DC1: 'DC1',
  DC2: 'DC2',
  DC4: 'DC4',
  DUME: 'DUME',
  REFERENCES: 'Références',
  CV_EQUIPE: 'CV équipe',
  RIB: 'RIB',
  POUVOIR: 'Pouvoir',
  STATUTS: 'Statuts',
  QUALIOPI: 'Qualiopi',
  QUALIBAT: 'Qualibat',
  OPQIBI: 'OPQIBI',
  MASE: 'MASE',
  HDS: 'HDS',
  CONFIDENTIEL_DEFENSE: 'Confidentiel Défense',
  SECRET_DEFENSE: 'Secret Défense',
  AUTRE: 'Autre',
};

export const PIECE_TYPES_ORDER: PieceType[] = [
  'KBIS',
  'ATTESTATION_URSSAF',
  'ATTESTATION_FISCALE',
  'ASSURANCE_RC_PRO',
  'STATUTS',
  'RIB',
  'POUVOIR',
  'DC1',
  'DC2',
  'DC4',
  'DUME',
  'ISO_9001',
  'ISO_14001',
  'ISO_27001',
  'QUALIOPI',
  'QUALIBAT',
  'OPQIBI',
  'MASE',
  'HDS',
  'CONFIDENTIEL_DEFENSE',
  'SECRET_DEFENSE',
  'REFERENCES',
  'CV_EQUIPE',
  'AUTRE',
];

/** Durée de validité par défaut (en mois) selon le type — proposé à l'upload. */
export const DEFAULT_VALIDITY_MONTHS: Partial<Record<PieceType, number>> = {
  KBIS: 3,
  ATTESTATION_URSSAF: 3,
  ATTESTATION_FISCALE: 3,
  ASSURANCE_RC_PRO: 12,
  ISO_9001: 36,
  ISO_14001: 36,
  ISO_27001: 36,
  QUALIOPI: 36,
  QUALIBAT: 48,
  OPQIBI: 48,
  MASE: 36,
  HDS: 36,
  CONFIDENTIEL_DEFENSE: 60,
  SECRET_DEFENSE: 60,
};

export const CERTIFICATION_TYPE_LABELS: Record<CertificationType, string> = {
  ISO_9001: 'ISO 9001 (Qualité)',
  ISO_14001: 'ISO 14001 (Environnement)',
  ISO_27001: 'ISO 27001 (Sécurité info)',
  QUALIOPI: 'Qualiopi',
  QUALIBAT: 'Qualibat',
  OPQIBI: 'OPQIBI',
  MASE: 'MASE',
  HDS: 'HDS (Hébergement données santé)',
  CONFIDENTIEL_DEFENSE: 'Confidentiel Défense',
  SECRET_DEFENSE: 'Secret Défense',
  AUTRE: 'Autre',
};

export const CERTIFICATION_TYPES_ORDER: CertificationType[] = [
  'ISO_9001',
  'ISO_14001',
  'ISO_27001',
  'QUALIOPI',
  'QUALIBAT',
  'OPQIBI',
  'MASE',
  'HDS',
  'CONFIDENTIEL_DEFENSE',
  'SECRET_DEFENSE',
  'AUTRE',
];

export const BLOCK_CATEGORY_LABELS: Record<BlockCategory, string> = {
  presentation_societe: 'Présentation société',
  politique_rse: 'Politique RSE',
  demarche_qualite: 'Démarche qualité',
  securite_rgpd: 'Sécurité & RGPD',
  methodologie_projet: 'Méthodologie projet',
  references_sectorielles: 'Références sectorielles',
  donnees_financieres: 'Données financières',
  ressources_humaines: 'Ressources humaines',
  charte_ethique: 'Charte éthique',
  autre: 'Autre',
};

export const BLOCK_CATEGORIES_ORDER: BlockCategory[] = [
  'presentation_societe',
  'politique_rse',
  'demarche_qualite',
  'securite_rgpd',
  'methodologie_projet',
  'references_sectorielles',
  'donnees_financieres',
  'ressources_humaines',
  'charte_ethique',
  'autre',
];
